<app-modal title="SLA Fiscal" [form]="form" [hideDefaultActions]="true">
  <form [formGroup]="form">
    <div class="tds-row">
      <app-input
        label="Senha"
        formControlName="senha"
        [readOnly]="true"
      ></app-input>
      <app-input
        label="Data Entrada"
        formControlName="dataEntrada"
        [readOnly]="true"
      ></app-input>
    </div>

    <div class="tds-row">
      <app-input label="Registro" formControlName="registro"></app-input>
    </div>

    <div class="tds-row tds-u-justify-around">
      <tds-checkbox formControlName="critico" checkboxId="critico-checkbox">
        <div slot="label">Crítico</div>
      </tds-checkbox>
      <tds-checkbox formControlName="milkrun" checkboxId="milkrun-checkbox">
        <div slot="label">Milkrun</div>
      </tds-checkbox>
      <tds-checkbox
        formControlName="controlCenter"
        checkboxId="controlcenter-checkbox"
      >
        <div slot="label">Control Center</div>
      </tds-checkbox>
    </div>

    <div class="tds-row tds-u-justify-around tds-u-mt2">
      <app-button
        text="Control Center Diretos"
        (clicked)="processar(fase.PRODUTIVO)"
      ></app-button>
      <app-button
        text="Control Center Indiretos"
        (clicked)="processar(fase.IMPRODUTIVO)"
      ></app-button>
    </div>

    <div class="tds-row tds-u-flex-end tds-u-mt2">
      <tds-button
        text="Cancelar"
        (click)="onClose()"
        variant="secondary"
      ></tds-button>
    </div>
  </form>
</app-modal>
